module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/dryShampoo_85530b.png";